/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { BakendHttpResponse } from '../../bakend-http-response';
import { RequestBuilder } from '../../request-builder';

import { BackendPatchedProductGroupRequestDto } from '../../models/backend-patched-product-group-request-dto';
import { BackendProductGroupDto } from '../../models/backend-product-group-dto';

export interface SalesGroupsPartialUpdate$FormData$Params {
  /**
   * A unique integer value identifying this product group.
   */
  id: number;
  body?: BackendPatchedProductGroupRequestDto;
}

export function salesGroupsPartialUpdate$FormData(
  http: HttpClient,
  rootUrl: string,
  params: SalesGroupsPartialUpdate$FormData$Params,
  context?: HttpContext,
): Observable<BakendHttpResponse<BackendProductGroupDto>> {
  const rb = new RequestBuilder(rootUrl, salesGroupsPartialUpdate$FormData.PATH, 'patch');
  if (params) {
    rb.path('id', params.id, {});
    rb.body(params.body, 'multipart/form-data');
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as BakendHttpResponse<BackendProductGroupDto>;
    }),
  );
}

salesGroupsPartialUpdate$FormData.PATH = '/api/sales/groups/{id}/';
